<div class="color-theme-2">
  <router-outlet></router-outlet>
</div>

